import { AdminReportingViewModel } from '../../../../viewmodels/AdminViewModels';
import { styleSheet } from './styles';
import { StyleDeclarationValue, css } from 'aphrodite';
import { observer } from 'mobx-react';
import moment from 'moment';
import * as React from 'react';
import { withRouter } from 'react-router';
import { RouteComponentProps } from 'react-router-dom';

interface IProps extends RouteComponentProps<any> {
	className?: string;
	reportsVM: AdminReportingViewModel;
	styles?: StyleDeclarationValue[];
}

class _NextMonthSection extends React.Component<IProps> {
	public render() {
		const { className, styles, reportsVM } = this.props;
		return (
			<div
				className={`${css(styleSheet.container, ...(styles || []))} next-month-section ${className || ''}`}
				onClick={this.onMonthlyRenewalClicked}
			>
				<div className={css(styleSheet.text)}>
					{' '}
					OK, what about {moment().add(1, 'months').format('MMM')} though???
					<br />
					{reportsVM?.nextMonthPercent}
				</div>
			</div>
		);
	}

	private onMonthlyRenewalClicked = () => {
		const { history } = this.props;
		const next = moment().add(1, 'months');
		// moment months are 0 indexed where 0 is january
		const month = next.month() + 1;
		const year = next.year();
		history.push(`/reports/monthly?month=${month}&year=${year}`);
	};
}

const NextMonthSectionAsObserver = observer(_NextMonthSection);
export const NextMonthSection = withRouter(NextMonthSectionAsObserver);
